import { OfferState } from '../../offer/model/OfferState';
import { OrderState } from '../model/OrderModel';

export const OrderTabEnum = {
    DRAFTED: 'drafted',
    ENQUIRED: 'enquired',
    ORDERED: 'ordered',
    DELIVERED: 'delivered',
    CANCELED: 'canceled',
};

export type OrderTab = (typeof OrderTabEnum)[keyof typeof OrderTabEnum];

export const orderTabStateFilter: Record<OrderTab, OrderState[]> = {
    drafted: [OrderState.DRAFT],
    enquired: [OrderState.OPEN],
    ordered: [OrderState.CLOSED],
    delivered: [OrderState.CLOSED],
    canceled: [OrderState.CANCELED, OrderState.CLOSED],
} as const;

export const orderTabOfferStateFilter: Partial<Record<OrderTab, OfferState[]>> = {
    ordered: [
        OfferState.ORDER,
        OfferState.CUSTOMER_ADJUSTED,
        OfferState.SUPPLIER_ADJUSTED,
        OfferState.CONFIRMED,
        OfferState.ACKNOWLEDGED,
    ],
    delivered: [OfferState.DELIVERED, OfferState.DELIVERY_CONFIRMED, OfferState.INVOICED],
    canceled: [OfferState.CANCELED, OfferState.QUOTE_CANCELED, OfferState.ENQUIRY_CANCELED],
} as const;
